import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useState, useContext, useCallback, } from "react";
export const TravelTimeContext = createContext(undefined);
export const TravelTimeProvider = ({ children }) => {
    const [isTravelTimeOpen, setIsTravelTimeOpen] = useState(true);
    const [loadingState, setLoadingState] = useState("idle");
    const [travelTimes, setTravelTimes] = useState([]);
    const resetTravelTime = useCallback(() => {
        setTravelTimes([]);
        setLoadingState("idle");
    }, []);
    const value = useMemo(() => ({
        loadingState,
        setLoadingState,
        travelTimes,
        setTravelTimes,
        resetTravelTime,
        isTravelTimeOpen,
        setIsTravelTimeOpen,
    }), [isTravelTimeOpen, loadingState, resetTravelTime, travelTimes]);
    return (_jsx(TravelTimeContext.Provider, { value: value, children: children }));
};
export const useTravelTimeContext = () => {
    const context = useContext(TravelTimeContext);
    if (context === undefined) {
        throw new Error("useTravelTimeContext must be used within a TravelTimeProvider");
    }
    return context;
};
